import { useState } from 'react';
import { Linkedin, Twitter, Mail, ExternalLink, ChevronDown, ChevronUp } from 'lucide-react';

// Default board members data structure
const defaultBoardMembers = [
  {
    id: 1,
    name: "Raja Devarapu",
    title: "Chair,Board of Director",
    image: "/images/raja.png",
    // bio: "Sarah brings over 25 years of experience in strategic leadership and financial management. Previously CEO of TechGlobal Inc., she has led multiple organizations through successful digital transformations.",
    links: {
      // linkedin: "https://www.linkedin.com/in/raja-devarapu/"
      //   twitter: "https://twitter.com/sarahjohnson",
      //   email: "sarah.johnson@company.com"
    }
  },
  {
    id: 2,
    name: "Kavit Pandya",
    title: "Vice chair, Board of Directors",
    image: "/images/kavit.png",
    // bio: "Michael is a renowned industry expert with expertise in sustainable business practices and global market expansion. He previously served as COO at InnovateNow and sits on multiple advisory boards.",
    links: {
      // linkedin: "https://www.linkedin.com/in/kavitpandya25/"
      //   twitter: "https://twitter.com/michaelchen",
      //   email: "michael.chen@company.com"
    }
  },
  {
    id: 3,
    name: "Prathap Repalle",
    title: "Treasurer, Board of Directors",
    image: "/images/prathap.png",
    // bio: "David has a strong background in finance and investment strategy. He currently serves as Managing Partner at Horizon Capital and brings valuable insights on market trends and capital allocation.",
    links: {
      // linkedin: "https://www.linkedin.com/in/prathap-repalle/"
      //   twitter: "https://twitter.com/davidokonkwo",
      //   email: "david.okonkwo@company.com"
    }
  },
  {
    id: 4,
    name: "Raju Garaga",
    title: "Head of Business Development, Board of Directors",
    image: "/images/raju.png",
    // bio: "Elena has extensive experience in regulatory compliance and risk management. As former General Counsel for DataSphere Technologies, she brings valuable legal expertise to our board.",
    links: {
      // linkedin: "https://www.linkedin.com/in/raju-garaga-9a5b6439/"
      //   email: "elena.rodriguez@company.com"
    }
  },
  {
    id: 5,
    name: "Christel Visser",
    title: "Board of Director",
    image: "/images/christel.png",
    // bio: "Priya is a technology innovator with expertise in AI and emerging technologies. As founder of TechFuture Labs, she provides crucial guidance on our technology roadmap and innovation strategy.",
    links: {
      // linkedin: "https://www.linkedin.com/in/christelvisser/"
      //   twitter: "https://twitter.com/priyasharma",
      //   email: "priya.sharma@company.com"
    }
  }
];

// Individual Board Member Card Component
const BoardMemberCard = ({ member }) => {
  return (
    <div className="bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl group flex flex-col h-full">
      <div className="w-full h-96 relative overflow-hidden bg-black flex items-center justify-center">
        <img 
          src={member.image} 
          alt={member.name} 
          className="w-80 h-80 object-cover rounded-full"
        />
      </div>
      
      <div className="p-6 text-center bg-white flex flex-col flex-grow">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
        <p className="text-blue-600 font-medium text-sm tracking-widest uppercase mb-6 flex-grow">{member.title}</p>
      
        <div className="flex justify-center space-x-5 pt-4 border-t border-gray-100 mt-auto">
          {member.links.linkedin && (
            <a href={member.links.linkedin} className="text-gray-400 hover:text-blue-600 transition-colors hover:-translate-y-1 transform duration-300">
              <Linkedin size={20} />
            </a>
          )}
          {member.links.twitter && (
            <a href={member.links.twitter} className="text-gray-400 hover:text-blue-400 transition-colors hover:-translate-y-1 transform duration-300">
              <Twitter size={20} />
            </a>
          )}
          {member.links.email && (
            <a href={`mailto:${member.links.email}`} className="text-gray-400 hover:text-red-500 transition-colors hover:-translate-y-1 transform duration-300">
              <Mail size={20} />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

// Main Board of Directors Component
export default function BoardOfDirectors({
  title = "Our Board of Directors",
  subtitle = "Meet the exceptional leaders guiding our company's vision and strategy",
  boardMembers = defaultBoardMembers,
  bgColor = "bg-gray-50"
}) {
  return (
    <section className={`py-16 ${bgColor}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {boardMembers.map(member => (
            <BoardMemberCard key={member.id} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
}